import logo from '../../../assets/images/footer-logo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div>
      <footer className='footer p-20 bg-[#021133] text-white'>
        <aside className='flex items-start gap-4'>
          {/* <div className="w-[50px] h-[50px] sm:w-[55px] sm:h-[55px] bg-white rounded-full overflow-hidden">
        <img src={logo} alt="" className="w-full h-full object-contain" />
      </div> */}
          {/* <div className="w-[55px] h-[55px] sm:w-[60px] sm:h-[60px] bg-white rounded-full overflow-hidden flex items-center justify-center">
        <img src={logo} alt="Logo" className="w-[100%] h-[100%] object-cover" />
      </div> */}
          <div className='w-[220px]   overflow-hidden flex items-center justify-center'>
            <img src={logo} alt='Logo' className=' -translate-y-1' />
          </div>

          <div>
            <p
              className='text-md font-bold text-[#ffffff]'
              style={{ marginTop: '8px' }}
            >
              SUNDARBAN CARGO SERVICES UK LTD
              <br />
              <span className='text-orange-500'>COURIER FOR THE COMMUNITY</span>
            </p>
          </div>
        </aside>

        <nav>
          <h6 className='footer-title'>Useful Links</h6>
          <Link className='link link-hover' to='/'>
            Home
          </Link>
          <Link className='link link-hover' to='/bookings'>
            Bookings
          </Link>
          <Link className='link link-hover' to='/contact-us'>
            Contact Us
          </Link>
        </nav>

        <nav>
          <h6 className='footer-title'>Legal</h6>
          <Link className='link link-hover' to='/terms-and-conditions'>
            Terms &amp; Conditions
          </Link>
          <Link className='link link-hover' to='/privacy-policy'>
            Privacy Policy
          </Link>
          <Link className='link link-hover' to='/refund-cancellation-policy'>
            Refund &amp; Cancellation Policy
          </Link>
        </nav>
      </footer>

      <footer className=' bg-[#021133] footer footer-center p-4  text-white border-t border-white/30'>
        <aside>
          <p>
            Copyright © 2026 - All Rights Reserved By Sundarban Cargo Team
          </p>
        </aside>
      </footer>
    </div>
  );
};

export default Footer;
